export default __webpack_public_path__ + "static/media/shape_4.e4d53424.svg";